export const ALL_CURRENCIES = [
  { id: "USD", code: "USD", symbol: "$", name: "US Dollar" },
  { id: "EUR", code: "EUR", symbol: "€", name: "Euro" },
  { id: "GBP", code: "GBP", symbol: "£", name: "British Pound" },
  { id: "PLN", code: "PLN", symbol: "zł", name: "Polish Złoty" },
  { id: "AED", code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { id: "AUD", code: "AUD", symbol: "A$", name: "Australian Dollar" },
  // { id: "CAD", code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
  // { id: "CHF", code: "CHF", symbol: "CHF", name: "Swiss Franc" },
  { id: "JPY", code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { id: "CNY", code: "CNY", symbol: "¥", name: "Chinese Yuan" },
];

export const SUPPORTED_CURRENCY_IDS = ["USD", "EUR", "GBP", "PLN", "AED", "AUD", "JPY", "CNY"];

export const isSupportedCurrency = (currency) => SUPPORTED_CURRENCY_IDS.includes((currency || "").toUpperCase());
